import clsx from "clsx";
import React, { ForwardedRef, forwardRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useScrollLockContext } from "../../contexts/scrollLockContext";

import CommonInput from "../Input/CommonInput";

type Props = {};

export default function SearchHeader(props: Props) {
  const [searchActive, setSearchActive] = useState(false);
  const navigate = useNavigate();

  const handleSearchClick = () => {
    setSearchActive(!searchActive);
  };

  const handleSearchSubmit = (searchQuery: string) => {
    navigate("/talk/search", { state: { searchQuery } });
  };

  const [, { lockScroll, unlockScroll }] = useScrollLockContext();

  useEffect(() => {
    if (searchActive) {
      const scrollId = lockScroll?.({});

      return () => {
        unlockScroll?.({ activeElements: [scrollId] });
      };
    }
  }, [searchActive]);

  return (
    <div className="relative w-full flex items-center">
      <button
        className={`focus:outline-none ${searchActive ? "text-blue-500" : ""}`}
        onClick={handleSearchClick}
      >
        {searchActive ? <TalkCloseSearchIcon /> : <TalkSearchIcon />}
      </button>
      {searchActive && (
        <>
          <div className=" bg-black opacity-60 fixed inset-0 top-[73.6px]"></div>
          <div className="fixed top-[64px] left-0 right-0  mx-auto">
            <TalkSearchInput onClick={handleSearchSubmit} />
          </div>
        </>
      )}
    </div>
  );
}

export const TalkCloseSearchIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 6L6 18"
      stroke="#EA27C2"
      strokeWidth="1.75"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M6 6L18 18"
      stroke="#EA27C2"
      strokeWidth="1.75"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

export type TalkSearchInputProps = {
  onClick?: (value: string) => void;
  className?: string;
  autoComplete?: string;
};

export const TalkSearchInput = forwardRef(
  (
    { onClick, className, autoComplete = "on" }: TalkSearchInputProps,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    const [value, setValue] = useState("");

    return (
      <div className="flex items-center w-full relative">
        {/* TODO: 텍스트 내용 제거하는 버튼 추가 */}
        <CommonInput
          placeholder="검색어를 입력해 주세요"
          value={value}
          onChange={(text) => setValue(text)}
          className={clsx([
            "bg-brand-talk-search border-none pr-12 rounded-none",
            className,
          ])}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onClick?.(value);
            }
          }}
          ref={ref}
          autoComplete={autoComplete}
          autoCorrect="off"
        />
        <button
          className="absolute right-0 mr-4"
          onClick={() => onClick?.(value)}
        >
          <TalkSearchIcon />
        </button>
      </div>
    );
  }
);

export const TalkSearchIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 21L15.8571 15.8571M10.7143 18.4286C6.4538 18.4286 3 14.9748 3 10.7143C3 6.4538 6.4538 3 10.7143 3C14.9748 3 18.4286 6.4538 18.4286 10.7143C18.4286 14.9748 14.9748 18.4286 10.7143 18.4286Z"
      stroke="#1D1929"
      strokeWidth="1.75"
    />
  </svg>
);
